<div class="container">
    <div class="card">
        <div class="card-body" style="min-height: 80vh;">
            <form [formGroup]="form">
                <div class="card col-md-12">
                    <div class="card-header"><h2 class="orange-border">Payment Details</h2></div>
                    <div class="row">
                        <div class="form-group col-md-6">
                            <validation [formGroup]="form"
                                        controlName="qrCodeDescription"
                                        displayName="QR code description">
                                <label for="qrCodeDescription">QR Code Description:</label>
                                <input [ngClass]="{'is-invalid': displayError(f.qrCodeDescription)}"
                                       class="form-control"
                                       formControlName="qrCodeDescription"
                                       id="qrCodeDescription"
                                       pTooltip="QR code description"
                                       type="text"/>
                                @if (isValidatingDescription) {
                                    <div class="d-flex align-items-center">
                                        <div aria-hidden="true"
                                             class="spinner-border spinner-border-sm spinner-position  ml-auto"
                                             role="status"></div>
                                    </div>
                                }

                            </validation>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-6">
                            <label for="exactAmountEnabled">Exact Amount Enabled: </label>
                            <i pTooltip="If enabled, this QR code will only allow an exact amount"></i>
                            <div class="form-inline">
                                <p-toggleswitch formControlName="exactAmountEnabled"
                                                id="exactAmountEnabled"></p-toggleswitch>
                                <h4 class="margin-toggle">{{ exactAmountEnabledLabel }}</h4>
                            </div>
                        </div>
                    </div>
                    @if (isExactAmountEnabled) {
                        <div class="row">
                            <div class="form-group col-md-6">
                                <validation [formGroup]="form" controlName="exactAmount" displayName="Exact amount">
                                    <label for="exactAmount">Exact Amount:</label>
                                    <div class="currency-input-wrapper">
                                        <span class="currency-prefix">R </span>
                                        <input appCurrencyMask
                                               [ngClass]="{ 'is-invalid': displayError(f.exactAmount)}"
                                               class="form-control currency-input"
                                               formControlName="exactAmount"
                                               id="exactAmount"
                                               pTooltip="The exact amount allowed for this QR code"
                                               type="text"/>
                                    </div>
                                </validation>
                            </div>
                            @if (isMultiPremiumEnabled) {
                                <div class="form-group col-md-6">
                                    <validation [formGroup]="form"
                                                controlName="multiPremiumOption"
                                                displayName="Multi premium option">
                                        <label for="multiPremiumOption">Multi Premium Option: </label>
                                        <i class="pi pi-question-circle tooltip-icon"
                                           pTooltip="The number of payments the customer is allowed to pay upfront."></i>
                                        <p-select [options]="multiPremiumOptions"
                                                  [ngClass]="{ 'is-invalid': displayError(f.multiPremiumOption)}"
                                                  class="form-control"
                                                  formControlName="multiPremiumOption"
                                                  id="multiPremiumOption"
                                                  optionLabel="value"
                                                  optionValue="value"
                                                  placeholder="-- Select multi premium option --"/>
                                    </validation>
                                </div>
                            }
                        </div>
                    }

                    @if (!isExactAmountEnabled || isMultiPremiumEnabled) {
                        <div class="row">
                            <div class="form-group col-md-6">
                                <validation [formGroup]="form" controlName="minimumAmount" displayName="Minimum amount">
                                    <label for="minimumAmount">Minimum Amount:</label>
                                    <div class="currency-input-wrapper">
                                        <span class="currency-prefix">R </span>
                                        <input appCurrencyMask
                                               [ngClass]="{ 'is-invalid': displayError(f.minimumAmount)}"
                                               class="form-control currency-input"
                                               formControlName="minimumAmount"
                                               id="minimumAmount"
                                               pTooltip="The minimum amount allowed for this QR code"
                                               type="text"/>
                                    </div>
                                </validation>
                                @if (displayError(f.minimumAmount)) {
                                    <div class="invalid-feedback">
                                        @if (f.minimumAmount.errors.invalidMinMax) {
                                            <div>
                                                Minimum amount cannot be more than maximum amount
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                            <div class="form-group col-md-6">
                                <validation [formGroup]="form" controlName="maximumAmount" displayName="Maximum amount">
                                    <label for="maximumAmount">Maximum Amount:</label>
                                    <div class="currency-input-wrapper">
                                        <span class="currency-prefix">R </span>
                                        <input appCurrencyMask
                                               [ngClass]="{ 'is-invalid': displayError(f.maximumAmount)}"
                                               class="form-control currency-input"
                                               formControlName="maximumAmount"
                                               id="maximumAmount"
                                               pTooltip="The maximum amount allowed for this QR code"
                                               type="text"/>
                                    </div>
                                </validation>
                                @if (displayError(f.maximumAmount)) {
                                    <div class="invalid-feedback">
                                        @if (f.maximumAmount.errors.invalidMinMax) {
                                            <div>
                                                Maximum amount cannot be less than minimum amount
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    }
                    <br>
                    <div>
                        <div class="card-header"><h3 class="orange-border">Payment Notification</h3></div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-4">
                            <label for="notification">Send Payment Notification: </label>
                            <i class="pi pi-question-circle tooltip-icon" pTooltip="If enabled, an SMS notification will be sent to the provided
                             number when a payment is made to this QR code."></i>
                            <div class="form-inline">
                                <p-toggleswitch (onChange)="updateSmsNotificationValidation()"
                                                formControlName="notification"
                                                id="notification"></p-toggleswitch>
                                <h4 class="margin-toggle">{{ sendPaymentNotificationLabel }}</h4>
                            </div>
                        </div>
                    </div>
                    @if (isSendPaymentNotification) {
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label for="smsNotificationNumber">Notification Mobile Number:</label>
                                <input [ngClass]="{ 'is-invalid': displayError(f.smsNotificationNumber) }"
                                       [showMaskTyped]="true"
                                       class="form-control"
                                       formControlName="smsNotificationNumber"
                                       id="smsNotificationNumber"
                                       mask="000-000-0000"
                                       type="text"/>
                                @if (displayError(f.smsNotificationNumber)) {
                                    <div class="invalid-feedback">
                                        @if (f.smsNotificationNumber.errors.required) {
                                            <div>Mobile number is required</div>
                                        }
                                        @if (f.smsNotificationNumber.errors.pattern) {
                                            <div>Invalid mobile number, expected
                                                format is 072-123-1234
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            </form>
            <div class="save-button row col-md-12">
                <button (click)="cancel()" class="navy-btn center btn-margin-top-bottom" type="button">Cancel&nbsp; <i
                        class="fa fa-close fa-lg"></i>
                </button>

                <div [pTooltip]="isSubscriptionValid && !isGuestAdminUser() ? null : getTooltipText"
                     class="disabled-tooltip-wrapper center">
                    <button (click)="submitQrCode()"
                            [disabled]="isGuestAdminUser() || !isSubscriptionValid || isFormInvalid"
                            class="navy-btn btn-margin-top-bottom">
                        Save&nbsp; <i class="fa fa-save fa-lg"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<ngx-ui-loader></ngx-ui-loader>
